import { BaseValidator } from './baseValidator';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import { ValidatorResult } from './validatorRule.constants';

export class UsernameFieldValidator extends BaseValidator {
    public JPUsernameRangeRule(value: string): ValidatorResult {
        const MIN_LENGTH = 8;
        const MAX_LENGTH = 100;

        if (value.length < MIN_LENGTH || value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'JPUsernameRangeRule',
                message: TranslationHelpers.getFormattedMessageProps('error.rakid.boundaries', {
                    min: MIN_LENGTH,
                    max: MAX_LENGTH,
                }),
            };
        }
        return null;
    }

    public EUUsernameRangeRule(value: string): ValidatorResult {
        const MIN_LENGTH = 8;
        const MAX_LENGTH = 128;
        if (value.length < MIN_LENGTH || value.length > MAX_LENGTH) {
            return {
                value: value,
                rule: 'EUUsernameRangeRule',
                message: TranslationHelpers.getFormattedMessageProps('error.rakid.boundaries', {
                    min: MIN_LENGTH,
                    max: MAX_LENGTH,
                }),
            };
        }
        return null;
    }
}
